'use client';
import { monadic } from './monadic.js';
import { variadic } from './variadic.js';
import { assemble } from '../assemble/assemble.js';

var defaultStrategy = function defaultStrategy(fn, options) {
    var _ref = options || {}, cache = _ref.cache, serializer = _ref.serializer;
    var strategy = fn.length === 1 ? monadic : variadic;
    return assemble(fn, this, strategy, cache == null ? void 0 : cache.create(), serializer);
};

export { defaultStrategy };
